import { render, staticRenderFns } from "./ActivixCheckbox.vue?vue&type=template&id=287c3440&"
import script from "./ActivixCheckbox.vue?vue&type=script&lang=js&"
export * from "./ActivixCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports